export default __webpack_public_path__ + "static/media/post-company-1.42220a9a.png";